import axios from 'axios';
import { curry } from 'ramda';
import config from '../../config';
import { getToken } from '../../util';


export default curry(async (to, from, subject, messageBody) => {
  const token = await getToken('portaltoken');

  return axios({
    method: 'post',
    url: `${config.emailServiceUrl}/api/v1/email/send`,
    headers: { Authorization: `Bearer ${token}` },
    data: {
      message: {
        type: 'mailrelay',
        to: [to],
        from,
        subject,
        body: Buffer.from(messageBody).toString('base64'),
      },
    },
  });
});
